import { redirect } from "react-router-dom";
import { validateToken } from "utils/checkAuthorization";
import { getUserDetails } from "utils/localStorageServices";

/**
 * Loader applied to all protected app/admin routes.
 * - Redirects unauthenticated users to /login
 * - Redirects users who have not completed onboarding to /onboarding
 */
export function protectedRouteLoader() {
  const userDetails = getUserDetails();
  const isAuthenticated = userDetails?.token && validateToken();

  if (!isAuthenticated) {
    return redirect("/login");
  }

  const onboardingComplete = localStorage.getItem("onboardingComplete");
  if (onboardingComplete !== "true") {
    return redirect("/onboarding");
  }

  return null;
}
